import { render, staticRenderFns } from "./gesContrats.vue?vue&type=template&id=edad8c7c"
import script from "./gesContrats.vue?vue&type=script&lang=js"
export * from "./gesContrats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports